<template>
	<div class="evaluate-list">
		<div class="title-name">查询前请选择医院及就诊人</div>
		<div class="drop-box">
			<a-select
				show-search
				:placeholder="HospitalName"
				option-filter-prop="children"
				style="width: 400px"
				:filter-option="filterOption"
				@change="handleChange"
			>
				<a-select-option
					v-for="item in hospitalSelectOptions"
					:key="item.id"
					:value="item.id"
				>
					{{ item.name }}
				</a-select-option>
			</a-select>
			<!-- <a-dropdown style="position: relative;" :overlayStyle="style">
        <a class="ant-dropdown-link">
          {{ HospitalName }}
          <a-icon type="down" />
        </a>
        <a-menu slot="overlay">
          <a-menu-item
            v-for="item in hospitalSelectOptions"
            :key="item.id"
            @click="changeHospital(item)"
          >
            <a href="javascript:;">{{ item.name }}</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown> -->
			<a-dropdown>
				<a class="ant-dropdown-link">
					{{ patientName }}
					<a-icon type="down" />
				</a>
				<a-menu slot="overlay">
					<a-menu-item
						v-for="it in patientOptions"
						:key="it.cardNo"
						@click="changePatient(it)"
					>
						<a href="javascript:;">{{ it.name }}</a>
					</a-menu-item>
				</a-menu>
			</a-dropdown>
		</div>

		<div class="card-box">
			<div class="isEvaluate">
				<div
					:class="{ 'cursor-point': true, Evaluate: isEvaluate }"
					@click="viewEvaluate(true)"
				>
					待评价
				</div>
				<div
					:class="{ 'cursor-point': true, Evaluate: !isEvaluate }"
					@click="viewEvaluate(false)"
				>
					已评价
				</div>
			</div>
			<div class="content-box" v-for="(item, index) in list" :key="index">
				<div class="cont-title">
					<div>就诊ID：{{ item.visitId }}</div>
					<div style="color:#FF840C" v-if="isEvaluate">待评价</div>
					<div style="color:#459DF7" v-else>已评价</div>
				</div>
				<div>
					<div class="hosp-info">
						<div>
							<span class="cont-name">医院：</span>
							<span>{{ item.hospitalName }}</span>
						</div>
						<div>
							<span class="cont-name">科室：</span>
							<span>{{ item.deptName }}</span>
						</div>
						<div>
							<span class="cont-name">医生：</span>
							<span>{{ item.doctorName }}</span>
						</div>
					</div>
					<div class="hosp-info">
						<div>
							<span class="cont-name">就诊时间：</span>
							<span>{{ item.objTime }}</span>
						</div>
						<div
							class="eva-this cursor-point"
							v-if="isEvaluate"
							@click="goEvalute(item)"
						>
							评价>
						</div>
					</div>
				</div>
				<div class="sure-eva" v-if="!isEvaluate">
					<div v-for="(it, index) in item.list" :key="index">
						<div class="sure-eva-title">
							<div class="eva-name">
								<span>
									{{
										it.objType == 2
											? '对医生的评价：'
											: '对医院的评价：'
									}}
								</span>
								<a-rate
									allow-half
									:value="it.star / 2"
									disabled
								/>
							</div>
							<div style="color:#666" v-if="it.objType == 2">
								{{ it.createTime }}
							</div>
						</div>
						<div class="eva-content-box">
							<a-tag
								v-for="(tag, tagIndex) in strSplit(
									it.content,
									it.objType == 2 ? doctorDict : hosDict,
									0
								)"
								:key="tagIndex"
								color="#459DF7"
								>{{ tag }}</a-tag
							>
						</div>
						<div class="eva-content-own">
							{{
								strSplit(
									it.content,
									it.objType == 2 ? doctorDict : hosDict,
									1
								)
							}}
						</div>
					</div>
				</div>
			</div>

			<!-- <a-pagination
        class="next-page"
        v-model="current"
        :total="totalCount"
        :defaultPageSize="form.pageSize"
        @change="onChange"
        show-less-items
      />-->
		</div>
		<Evaluate :dataForm="dataForm" ref="evaThis"></Evaluate>
		<template v-if="total > 0">
			<div>
				<a-pagination
					show-quick-jumper
					:default-current="current"
					:total="total"
					@change="changecurrent"
				/>
				<br />
			</div>
		</template>
	</div>
</template>
<script>
import Evaluate from '@/components/Evaluate'
import { hospitalSelect, getUserinured, saveUserinured } from '@/api/register'
import {
	reservedToBeCommentedList,
	reservedCommentedList,
	getInPatient,
} from '@/api/evaluate-list'
import { getDict } from '@/api/registered'
export default {
	components: {
		Evaluate,
	},
	data() {
		return {
			current: 1,
			total: 0,
			form: {
				pageNum: 1,
				pageSize: 6,
				memberId: '',
			},

			hospitalSelectOptions: [],
			patientOptions: [],
			HospitalName: '',
			patientName: '',
			hospitalId: '',
			cardNo: '',
			recordId: '',

			isEvaluate: true,
			EvaluateList: [],

			doctorDict: [],
			hosDict: [],
			dataForm: {},
			style: {
				maxHeight: '600px',
				overflow: 'scroll',
				overflowX: 'hidden',
			},
		}
	},
	created() {
		this.getData()
		// this.getEvaluate()
		this.initDict()
	},
	methods: {
		handleChange(value) {
			this.hospitalId = value
			this.currPage = 1
			this.getEvaluate()
		},
		filterOption(input, option) {
			return (
				option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
			)
		},

		getPopupContainer() {
			return document.getElementById('box')
		},
		changecurrent(page) {
			window.scrollTo(0, 0)
			this.current = page
		},
		async getData() {
			let hosList = await hospitalSelect()
			this.hospitalSelectOptions = hosList.data
			//获取就诊人列表
			this.patientOptions = JSON.parse(
				localStorage.getItem('sysUser')
			).relationRecords
			getUserinured({
				memberId: JSON.parse(localStorage.getItem('sysUser')).id,
			})
				.then((res) => {
					this.HospitalName = res.data.hospital.name
					this.hospitalId = res.data.hospital.id
					this.patientName = res.data.record.name
					this.cardNo = res.data.record.cardNo
					this.recordId = res.data.record.id
				})
				.catch(async () => {
					this.HospitalName = hosList.data[0].name
					this.hospitalId = hosList.data[0].id

					this.patientName = this.patientOptions[0].name
					this.cardNo = this.patientOptions[0].cardNo
					this.recordId = this.patientOptions[0].recordId
				})
				.finally(() => {
					this.getEvaluate()
				})
		},
		//选择医院
		changeHospital(val) {
			console.log(val, '医院信息')
			this.HospitalName = val.name
			this.hospitalId = val.id
			this.getEvaluate()
		},
		//获取评价列表
		async getEvaluate() {
			let data = {
				cardno: this.cardNo,
				orgcode: this.hospitalId,
				recordId: this.recordId,
			}
			if (!this.isEvaluate) {
				let res = await reservedCommentedList(data)
				if (res.code == 200) {
					this.EvaluateList = res.data.list
					this.total = res.data.list.length
					this.current = 1
				} else {
					this.EvaluateList = []
					this.total = 0
					this.current = 1
				}
				// this.totalCount = res.data.totalCount
				// this.currPage = res.data.currPage
			} else {
				let res = await getInPatient(data)
				console.log('res=====>', res)
				if (res.code == 200) {
					this.total = res.data.length
					this.EvaluateList = res.data || []
					this.current = 1
				} else {
					this.EvaluateList = []
					this.total = 0
					this.current = 1
				}
				// this.totalCount = res.data.totalCount
				// this.currPage = res.data.currPage
			}
			saveUserinured({
				memberId: JSON.parse(localStorage.getItem('sysUser')).id,
				hospitalId: this.hospitalId,
				recordId: this.recordId,
			})
		},
		//获取字典医生医院评价关键字
		async initDict() {
			var list = [
				{
					type: 'DOCTOR_IMPRESSION',
				},
				{
					type: 'HOSP_IMPRESSION',
				},
			]
			list.map(async (item) => {
				var res = await getDict(item)
				//医生评价关键字
				if (item.type == 'DOCTOR_IMPRESSION') {
					this.doctorDict = res.data
				}
				//医院评价关键字
				if (item.type == 'HOSP_IMPRESSION') {
					this.hosDict = res.data
				}
			})
		},
		//字符串处理
		strSplit(str, dict, num) {
			var arr = str.split('|||')
			var content = ''
			arr = arr.filter((item) => {
				var save = dict.some((d) => {
					return d.text == item
				})
				if (save) {
					return item
				} else {
					content = item
				}
			})
			return !num ? arr || [] : content
		},
		onChange(pageNumber) {
			this.form.pageNum = pageNumber
			this.getEvaluate()
			console.log(123)
		},
		//选择就诊人
		changePatient(val) {
			this.patientName = val.name
			this.cardNo = val.cardNo
			this.recordId = val.recordId
			this.getEvaluate()
		},
		//是否评价更改
		viewEvaluate(val) {
			if (val != this.isEvaluate) {
				this.isEvaluate = val
				this.getEvaluate()
			}
		},
		//去评价
		goEvalute(dataForm) {
			this.dataForm = dataForm
			this.$refs.evaThis.onShow()
		},
	},
	mounted() {},
	computed: {
		list() {
			let { EvaluateList, current, total } = this
			let min, max
			if (EvaluateList.length > 0 && EvaluateList.length <= 10) {
				return EvaluateList
			}
			if (EvaluateList.length > 10) {
				if (current == 1) {
					min = 0
					max = 10
				} else {
					min = current * 10 - 10
					max = min + 10
				}
				if (max > total - 1) {
					max = total - 1
				}
				console.log(min, max)
				return EvaluateList.slice(min, max)
			}
			return []
		},
	},
}
</script>
<style lang="less" scoped>
.evaluate-list {
	.title-name {
		font-size: 20px;
		font-weight: 400;
		color: #3385ed;
	}
	.drop-box {
		margin-top: 22px;
		a {
			background: #f9f9f9;
			border: 1px solid #eeeeee;
			border-radius: 4px;
			padding: 13px 16px;
			font-size: 16px;
			font-weight: 400;
			color: #3385ed;
			i {
				margin-left: 50px;
			}
		}
		a:first-child {
			margin-right: 50px;
		}
	}
	.ant-select {
		background: #f9f9f9;
		margin-right: 50px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		padding: 7px 16px;
		font-size: 16px;
		font-weight: 400;
		/deep/.ant-select-selection--single {
			background: #f9f9f9;
			border: 0;
			.ant-select-selection__placeholder {
				color: #3385ed;
			}
			.ant-select-selection-selected-value {
				color: #3385ed;
			}
		}
	}

	.card-box {
		margin-top: 25px;
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 100px;
		.isEvaluate {
			display: flex;
			margin-left: 50%;
			transform: translateX(-50%);
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #999999;
			align-items: center;
			margin-bottom: 23px;
			div {
				width: 102px;
				height: 40px;
				background: #f9f9f9;
				font-size: 18px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #999999;
				line-height: 40px;
				text-align: center;
			}
			div:first-child {
				border-radius: 5px 0px 0px 5px;
			}
			div:nth-child(2) {
				border-radius: 0px 5px 5px 0px;
			}
			.Evaluate {
				background: #0079fe;
				color: #fff;
			}
		}

		.content-box {
			width: 100%;
			padding: 20px;
			background: #ffffff;
			border: 1px solid #cdcdcd;
			border-radius: 10px;
			margin-bottom: 30px;
			& > div {
				padding: 0 14px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #666666;
				line-height: 46px;
			}
			.cont-title {
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #dddddd;
			}
			.cont-name {
				color: #333333;
			}
			.hosp-info {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
			.eva-this {
				width: 90px;
				height: 34px;
				background: #459df7;
				border-radius: 10px;
				font-size: 18px;
				font-weight: 400;
				color: #ffffff;
				text-align: center;
				line-height: 34px;
			}
			.sure-eva {
				border-top: 1px solid #dddddd;
				margin-top: 21px;
				padding-top: 25px;
				.sure-eva-title {
					display: flex;
					justify-content: space-between;
					.eva-name {
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #333333;
					}
					/deep/ .ant-rate-star {
						i {
							font-size: 24px;
						}
					}
				}
			}
		}
		.next-page {
			margin-top: 70px;
			margin-left: 480px;
			/deep/ li {
				width: 50px;
				height: 50px;
				line-height: 50px;
			}
		}
	}
}
</style>
